"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "calculateNudgeList", {
    enumerable: true,
    get: function() {
        return calculateNudgeList;
    }
});
const _const = require("../const/const");
/**
 * Scans the trace in a given direction to find indices containing valid data.
 */ function getValidIndices(trace, headerLength, startIndex, direction, maxCount) {
    const indices = [];
    let probe = startIndex + direction;
    while(probe >= 0 && probe < headerLength && indices.length < maxCount){
        if (trace[probe] !== _const.MISSING_DATA_SENTINEL) {
            indices.push(probe);
        }
        probe += direction;
    }
    return indices;
}
/**
 * Constructs a NudgeEntry based on the target index and its preceding valid index.
 */ function createNudgeEntry(header, trace, anomalyData, displayIndex, targetIndex, prevValidIndex, xOffset, isLegacy) {
    if (isLegacy) {
        // If there's a previous valid point in the trace, start_revision is the commit after it.
        // Otherwise, fallback to the target index's own offset
        // (e.g., the very first point in the trace).
        const start_revision = prevValidIndex !== null ? header[prevValidIndex].offset + 1 : header[targetIndex].offset;
        return {
            display_index: displayIndex,
            anomaly_data: anomalyData,
            selected: displayIndex === 0,
            start_revision: start_revision,
            end_revision: header[targetIndex].offset,
            display_commit_number: header[targetIndex].offset,
            x: targetIndex - xOffset,
            y: trace[targetIndex]
        };
    } else {
        return {
            display_index: displayIndex,
            anomaly_data: anomalyData,
            selected: displayIndex === 0,
            start_revision: anomalyData.anomaly.start_revision,
            end_revision: anomalyData.anomaly.end_revision,
            display_commit_number: header[targetIndex].offset,
            x: targetIndex - xOffset,
            y: trace[targetIndex]
        };
    }
}
function calculateNudgeList(trace, header, currentIndex, anomalyData, nudgeRange = 2, xOffset = 0, isLegacy = true) {
    const nudgeList = [];
    const headerLength = header.length;
    if (currentIndex < 0 || currentIndex >= headerLength) {
        return nudgeList;
    }
    // Gather valid indices to the left (need nudgeRange + 1 to calculate start_revision)
    const leftIndices = getValidIndices(trace, headerLength, currentIndex, -1, nudgeRange + 1);
    // Gather valid indices to the right
    const rightIndices = getValidIndices(trace, headerLength, currentIndex, 1, nudgeRange);
    for(let i = -nudgeRange; i <= nudgeRange; i++){
        if (i < 0) {
            const leftPos = Math.abs(i) - 1; // i = -1 -> index 0
            if (leftPos < leftIndices.length) {
                const targetIndex = leftIndices[leftPos];
                const prevValidIndex = leftPos + 1 < leftIndices.length ? leftIndices[leftPos + 1] : null;
                nudgeList.push(createNudgeEntry(header, trace, anomalyData, i, targetIndex, prevValidIndex, xOffset, isLegacy));
            }
        } else if (i === 0) {
            const prevValidIndex = leftIndices.length > 0 ? leftIndices[0] : null;
            nudgeList.push(createNudgeEntry(header, trace, anomalyData, 0, currentIndex, prevValidIndex, xOffset, isLegacy));
        } else if (i > 0) {
            const rightPos = i - 1; // i = 1 -> index 0
            if (rightPos < rightIndices.length) {
                const targetIndex = rightIndices[rightPos];
                let prevValidIndex;
                if (i === 1) {
                    // The previous point is either the current index (if valid), or the first valid point to the left.
                    prevValidIndex = trace[currentIndex] !== _const.MISSING_DATA_SENTINEL ? currentIndex : leftIndices.length > 0 ? leftIndices[0] : null;
                } else {
                    prevValidIndex = rightIndices[rightPos - 1];
                }
                nudgeList.push(createNudgeEntry(header, trace, anomalyData, i, targetIndex, prevValidIndex, xOffset, isLegacy));
            }
        }
    }
    return nudgeList;
}
